import React, {useEffect, useRef} from 'react';
import AutoSidebarMenu from './AutoSidebarMenu';
import i18n from 'i18n';
import useOptimizedConfig from '@/hooks/useOptimizedConfig';
import CellLoader from '@/components/loading/CellLoader';

const SidebarMenu = React.memo(() => {
    const {config, loading} = useOptimizedConfig();
    const scrollSidebarRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (scrollSidebarRef.current && config) {
            const element = scrollSidebarRef.current;
            element.style.overflowY = 'auto';
            element.style.overflowX = 'hidden';
            element.style.height = 'calc(100vh - 140px)';
            element.style.paddingBottom = '60px';
        }
    }, [config]);

    if (loading || !config) {
        return <CellLoader text={i18n.t('loading_configuration.text')} />;
    }

    return (
        <>
            <div className="scroll-sidebar" ref={scrollSidebarRef}>
                <div className="user-profile">
                    <div className="profile-text">
                        {i18n.t('sb_site_name.text', {siteName: config.FCONST.SITENAME})}
                    </div>
                </div>
                <nav className="sidebar-nav">
                    <ul id="sidebarnav">
                        <AutoSidebarMenu />
                    </ul>
                </nav>
            </div>
            <div className="sidebar-footer">
                <a
                    href={config.URLS.publicApiDoc}
                    className="link"
                    data-toggle="tooltip"
                    title={i18n.t('jt_api_documentation.text')}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {i18n.t('sb_api.text')}
                </a>
            </div>
        </>
    );
});

export default SidebarMenu;